<template>
    <div class="login-wrapper">
      <!-- <Logo :isTitle="true" :width="200" :color="'green'" :clickable="true" /> -->
      <v-toolbar-title class="taption-logo no-nav">
      <router-link :to="getLogoUrl">
        <img alt="logo" :src='"../assets/images/logo_green_title.webp"' style="height:52px; width: 200px; display: block"/>
      </router-link>
      </v-toolbar-title>
      <section ref="authenticationform" class="authentication-form">
        <div ref="logincontainer" class="login-container">
          <h2 class="title text-center">
            <span>{{$lang.login.member_login}}</span>
          </h2>
          <div v-show="!isInAppBrowser" class="login-card card" >
                 <div>{{$lang.login.login_desc}}</div>
                 <span class="referral-note">*{{$lang.login.referral_note}}</span>
              </div>
              
          <div v-show="isInAppBrowser" class="form-unsupported card">
            <form class="theme-form">
              <div class="or-saparator">
                <span>{{$lang.home.browser_unsupported_title}}</span>
              </div>
                <div class="unsupported-desc">{{$lang.home.browser_unsupported_mobile_desc}}</div>
                <div class="unsupported-step1">{{$lang.home.browser_unsupported_step1}}</div>
                <div class="unsupported-step2">{{$lang.home.browser_unsupported_step2}}</div>
            </form>
          </div>
          <div v-show="!isInAppBrowser" class="card">
            <form class="theme-form">
              <div class="form-button text-center social-btns">
                <v-btn :disabled="isLoginLoading" class="round ggl" type="button" @click="googleLogin">
                  <span class="google-button__icon"><svg height="20px" viewBox="0 0 366 372" width="20px" xmlns="http://www.w3.org/2000/svg"><path d="M125.9 10.2c40.2-13.9 85.3-13.6 125.3 1.1 22.2 8.2 42.5 21 59.9 37.1-5.8 6.3-12.1 12.2-18.1 18.3l-34.2 34.2c-11.3-10.8-25.1-19-40.1-23.6-17.6-5.3-36.6-6.1-54.6-2.2-21 4.5-40.5 15.5-55.6 30.9-12.2 12.3-21.4 27.5-27 43.9-20.3-15.8-40.6-31.5-61-47.3 21.5-43 60.1-76.9 105.4-92.4z" fill="#EA4335" id="Shape"></path><path d="M20.6 102.4c20.3 15.8 40.6 31.5 61 47.3-8 23.3-8 49.2 0 72.4-20.3 15.8-40.6 31.6-60.9 47.3C1.9 232.7-3.8 189.6 4.4 149.2c3.3-16.2 8.7-32 16.2-46.8z" fill="#FBBC05" id="Shape"></path><path d="M361.7 151.1c5.8 32.7 4.5 66.8-4.7 98.8-8.5 29.3-24.6 56.5-47.1 77.2l-59.1-45.9c19.5-13.1 33.3-34.3 37.2-57.5H186.6c.1-24.2.1-48.4.1-72.6h175z" fill="#4285F4" id="Shape"></path><path d="M81.4 222.2c7.8 22.9 22.8 43.2 42.6 57.1 12.4 8.7 26.6 14.9 41.4 17.9 14.6 3 29.7 2.6 44.4.1 14.6-2.6 28.7-7.9 41-16.2l59.1 45.9c-21.3 19.7-48 33.1-76.2 39.6-31.2 7.1-64.2 7.3-95.2-1-24.6-6.5-47.7-18.2-67.6-34.1-20.9-16.6-38.3-38-50.4-62 20.3-15.7 40.6-31.5 60.9-47.3z" fill="#34A853"></path></svg></span>
                  {{$lang.login.signin_google}}
                </v-btn>
              </div>
  
              <div class="or-saparator">
                <span>{{$lang.login.or}}</span>
              </div>
  
              <div class="form-group">
                <input
                  v-model="email"
                  autocomplete="username"
                  :disabled="isLoginLoading"
                  type="email"
                  class="form-control"
                  :placeholder="$lang.login.email_address"
                />
              </div>
              <div class="form-group">
                <input
                  v-model="password"
                  :disabled="isLoginLoading"
                  :type="showpassword ? 'password' : 'text'"
                  name="login[password]"
                  autocomplete="current-password"
                  class="form-control"
                  :placeholder="$lang.login.password"
                />
                <div v-on:click="showpassword = !showpassword" class="show-hide">
                  <span :class="{show:showpassword}"></span>
                </div>
              </div>
              <v-expand-transition>
                <v-card class="none" v-show="!!loginError" height="auto" width="100%">
                  <span class="error-message">{{ loginError }}</span>
                  <a
                    v-show="errorCode==='verify_email'"
                    class="taption-link"
                    style="font-size:12px"
                    @click="resendVerification"
                  >{{$lang.login.resend_verification}}</a>
                </v-card>
              </v-expand-transition>
  
              <div class="form-button text-center">
                <v-btn
                  class="round login"
                  color="success"
                  :loading="isLoginLoading"
                  :disabled="isLoginLoading"
                  type="button"
                  @click="login"
                >{{$lang.login.login}}</v-btn>
              </div>
  
              <div class="terms-privacy">
                {{$lang.login.term_of_service_description1}}<a @click="onTerms">{{$lang.login.term_of_service}}</a>
                {{$lang.login.term_of_service_description2}}<a @click="onPrivacy">{{$lang.login.privacy_policy}}</a>
              </div>
  
              <v-layout wrap class="search-container">
                <a class="taption-link" @click="signup">{{$lang.login.create_an_account}}</a>
                <v-flex></v-flex>
                <a class="taption-link" @click="forgotPassword">{{$lang.login.forgot_password}}</a>
              </v-layout>
            </form>
          </div>
        </div>
      </section>
    </div>
  </template>
  <script>
  /* global tap_google */
  /* global tap_microsoft */
  import textHelper from "@/utils/textManager";
  import UserService from '../connections/user.service';

  export default {
    name: "LoginPage",
    data() {
      return {
        email: "",
        password: "",
        loginError: "",
        errorCode: "",
        showpassword: true,
        isLoginLoading: false
      };
    },
    computed:{
      isInAppBrowser(){
        return false;
          // var ua = navigator.userAgent || navigator.vendor || window.opera;
          // return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1 || ua.indexOf('Instagram') > -1;
          ////return !browser || ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1 || ua.indexOf('Instagram') > -1 || browser.name==='facebook' || browser.name ==='safari';
      },
      getLogoUrl() {
        const language =  textHelper.getDisplayLanguage();
        
        // Build query parameters using utility function
        const queryParams = textHelper.buildQueryParams();
        
        let routeName;
        if(language === 'zh'){
          routeName = "taptiontw";
        }
        else if(language === 'zh-CN'){
          routeName = "taptioncn";
        }
        else if(language === 'en-US' || language === 'en'){
          routeName = "taption";
        }
        else{
          routeName = `taption${language}`;
        }
        
        const routeObj = { name: routeName };
        
        // Only add query object if there are parameters
        if(Object.keys(queryParams).length > 0) {
          routeObj.query = queryParams;
        }
        
        return routeObj;
      }
    },
    methods: {
      login: function() {
        const me = this;
        me.isLoginLoading = true;
        UserService.getUserLoginPromise(me.email, me.password).then(
            function(result) {
              if (result.user.emailVerified) {
                return result.user.getIdToken();
              } else {
                me.errorCode = "verify_email";
                me.loginError = me.$lang.error["verify_email"];
                return Promise.resolve(false);
              }
            },
            function(err) {
              me.loginError = me.$lang.error[err.code];
              me.errorCode = err.code;
              return Promise.resolve(false);
            }
          )
          .then(function(idtoken){
            if(idtoken){
              return UserService.appSignIn('login',idtoken);
            }

            return Promise.resolve(false);
          })
          .then(function(result){
            if(result){
              UserService.navigateToAppLoginPage();
            }
            else{
              me.isLoginLoading = false;
            }
          })
      },
      onPrivacy(){
        const me = this;
        const routeData = me.$router.resolve({name: 'privacy'});
        window.open(routeData.href, '_blank');
      },
      onTerms(){
        const me = this;
        const routeData = me.$router.resolve({name: 'terms'});
        window.open(routeData.href, '_blank');
      },
      resendVerification: function() {
        const me = this;
        UserService
          .getUserLoginPromise(me.email, me.password)
          .then(function() {
            UserService.sendEmailVerification();
          });

          const message = {
              title:me.$lang.login.send_to_verify_header,
              body: me.$lang.login.send_to_verify + '<div class="fading-line"></div>'
            }
            me.$dialog.alert(message,{
              customClass: 'taption-dialog alert',
              okText: me.$lang.common.ok,
              html:true
            });
      //me.$globalConfirmationDialog.open(option);
      },
      signup: function() {
        const me = this;
        
        // Build query parameters using utility function
        const queryParams = textHelper.buildQueryParams();
        
        const routeObj = { name: "signup" };
        
        // Only add query object if there are parameters
        if(Object.keys(queryParams).length > 0) {
          routeObj.query = queryParams;
        }
        
        me.$router.push(routeObj);
      },
      forgotPassword: function() {
        const me = this;

        me.$dialog.prompt({
          title:  me.$lang.login.forgot_password+'<div class="fading-line"></div>'
        }, {
          customClass: 'taption-dialog',
          promptHelp:me.$lang.common.email_placeholder.replace('...',':'),
          okText: me.$lang.common.send,
          cancelText: me.$lang.common.cancel,
          html:true
        })
        .then(function(data){
          const forgotEmail = data.data;

          var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
        if (forgotEmail && regex.test(forgotEmail)) {
            UserService.sendPasswordResetEmail(forgotEmail);
            me.$dialog.alert(me.$lang.login.check_to_reset+'<div class="fading-line"></div>',{
              customClass: 'taption-dialog alert',
              okText: me.$lang.common.ok,
              html:true
            });
        }
        else{
          me.$dialog.alert(me.$lang.error.email_must_be_valid+'<div class="fading-line"></div>',{
          customClass: 'taption-dialog alert error',
          okText: me.$lang.common.ok,
          html: true
         });
        }
        })
        .catch(() => {
          // Triggered when dialog is dismissed by user
          console.log('');
        });
      },
      googleLogin2: function() {
        const me = this;
        const provider = UserService.getGoogleAuthProvider();
        provider.setCustomParameters({
          prompt: 'select_account'
        });
        me.isLoginLoading = true;
     //   me.$store.dispatch('reset')
        UserService.getSignInWithPopupPromise(provider).then(
          function(user) {
              if(user.additionalUserInfo && user.additionalUserInfo.isNewUser){
               // window.dablena('track', 'CompleteRegistration');
               
                //   gtag('event', 'register');
                //   gtag_report_conversion('signup');
                //   uet_report_conversion('signup');
                  
              }

              return user.user.getIdToken();
          },
          function(err) {
            me.loginError = me.$lang.error[err.code];
            me.errorCode = err.code;
            me.isLoginLoading = false;
            return Promise.resolve(false);
          }
        ).then(function(idtoken){
          return UserService.appSignIn('login',idtoken);
        }).then(function(){
          UserService.navigateToAppLoginPage();
        }).finally(function() {
          me.isLoginLoading = false;
        });
      },
      googleLogin: async function() {
        const me = this;
        
        // Extract tracking parameters from browser URL
        const trackingData = UserService.extractTrackingParameters();
        
        if (trackingData.advertiserId && process.env.VUE_APP_SUPPORT_ADVERTISER.indexOf(trackingData.advertiserId) > -1) {
           UserService.storeTrackingData(trackingData);
        }
        
        const provider = UserService.getGoogleAuthProvider();
        provider.setCustomParameters({
          prompt: 'select_account'
        });
        me.isLoginLoading = true;
        
        UserService.getSignInWithPopupPromise(provider).then(
          function(result) {
              const isNewUser = result.user && result.user.metadata && 
                               result.user.metadata.createdAt === result.user.metadata.lastLoginAt;
              
              if(isNewUser && process.env.VUE_APP_MODE && process.env.VUE_APP_MODE === 'production'){
               // window.dablena('track', 'CompleteRegistration');
               
                //   gtag('event', 'register');
                tap_google('signup');
                tap_microsoft('signup');
              }

              return result.user.getIdToken();
          },
          function(err) {
            me.loginError = me.$lang.error[err.code];
            me.errorCode = err.code;
            me.isLoginLoading = false;
            return Promise.resolve(false);
          }
        ).then(function(idtoken){
          if(idtoken){
            return UserService.appSignIn('login',idtoken);
          }

          return Promise.resolve(false);
        }).then(function(navigate){
          if(navigate){
            UserService.navigateToAppLoginPage();
          }
          else{
            me.isLoginLoading = false;
          }
        });
      },
    },
    async mounted() {
      const me = this;
      me.isLoginLoading = false;
      
      me.$refs.authenticationform.addEventListener('keyup', function(event) {
        if (event.keyCode === 13) { 
          me.login();
        }
      });
  
      setTimeout(function() {
        me.$refs.logincontainer.classList.add("show");
      }, 100);
    }
  };
  </script>
  
  <style>
  .v-btn.round {
    width: 100% !important;
    height: 45px !important;
    margin: 20px 0px !important;
  }
  
  .authentication-form{
      padding-top: 130px;
  }
  
  .authentication-form .card {
    height:auto!important;
  }
  
  .login-container {
    -webkit-transition: all 200ms ease-in;
    -moz-transition: all 200ms ease-in;
    -o-transition: all 200ms ease-in;
    transition: all 200ms ease-in;
    opacity: 0;
  }
  .login-container.show {
    opacity: 1 !important;
  }
  .v-card.none {
    border: 0;
    box-shadow: none;
  }

  @media (max-width: 992px) {
    .authentication-form .card {
      width: 90% !important; 
      margin-top: 0px !important;
    }
  }
  @media only screen and (max-device-width: 600px) {
  .authentication-form .card {
      width: 100% !important; 
    margin-top: 0px !important;
    
  }
  .authentication-form {
    padding-bottom: 0px;
  }
  
  }
  </style>
  
  <style scoped>
  .card {
    -webkit-box-shadow: 0 1px 4px rgba(1, 1, 1, 0.15);
    box-shadow: 0 1px 4px rgba(1, 1, 1, 0.15);
    cursor: default !important;
    min-height: 450px;
    height: auto;
  }
  
  .form-unsupported.card{
    min-height: 200px;
  }
  
  .creating-message {
    color: #0062ff;
    margin: 0px;
    font-size: 13px;
  
  }
  .logo {
      position: absolute;
      top: 42px;
      left: 75px;
  }
  .login-card.card{
      height:40px!important;
      min-height: 40px;
      text-align: center;
  }
  
  .login-wrapper{
    height:100%;
    background: rgb(216 240 236 / 20%);
  }
  
  .login-wrapper section{
    height:inherit;
  }
  
  .v-btn {
    width: 220px;
    margin: 6px;
  }
  
  .social-btns .firebaseui-idp-icon {
    margin-right: 20px;
    margin-bottom: 5px;
  }
  
  .social-btns .ggl {
    width: 100%!important;
    background-image: none;
    background-color: white!important;
      color: gray!important;
    text-transform: none !important;
    font-family: Roboto, sans-serif;
        letter-spacing: 0.5px;
  }
  
  .social-btns .ggl::before {
    transition: none;
    background-color: white!important;
    background-image: none;
    -webkit-box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)!important;
    box-shadow: 0px 3px 15px 2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)!important;
  }
  
  .google-button__icon{
    padding: 8px;
  }
  
  .social-btns .fb {
    color: white !important;
    text-transform: none !important;
  }
  
  .terms-privacy{
    color:#878383;
    font-size:12px;
    padding-bottom: 10px;
    text-align: center;
  }
  
  .terms-privacy a{
    text-decoration: underline!important;
    color:gray!important;
  }
  
  .referral-note{
      position:absolute;
      color:gray;
      font-size: 12px;
      right:50px;
      bottom:10px;
  }
  .unsupported-desc{
    width:100%;
    text-align: center;
  }
  .unsupported-step1{
    margin-top:20px;
  }
  .unsupported-step2,
  .unsupported-step1{
    color:gray;
  }

  .authentication-form{
    justify-content: center;
    display: flex;
    align-items: center;
    margin-top: 0px !important;
    padding-top:0px!important;
    
  }

  .login-container{
    height:inherit;
  }

  .authentication-form .card {
    border: 0;
    padding: 25px 50px 50px;
    width: 500px;
    margin: 0 auto;
    border-radius: 0px 0px 10px 10px;
    box-shadow: 0 1px 10px rgba(1, 1, 1, 0.25);
    background: white;
  }

  .authentication-form .login-card{
    border-radius: 10px 10px 0px 0px;
    position:relative;
    border-bottom: 3px solid #1ad7dd !important;
  }
  button{
    border-radius: 20px;
  }
  a.taption-link {
    text-decoration: underline !important;
    font-size: 14px;
    color: #2fc59f !important;
}
.error-message{
    color:red;
}
.authentication-form .none{
  box-shadow: none;
    font-size: 12px;
    text-align: left;
}
  </style>